module.exports = __webpack_public_path__ + "static/media/banner_supernowa-half.8b2e8ccb.png";